import { Injectable, inject } from '@angular/core';
import _ from 'lodash';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../../../core/models/api-response.models';
import { AuditLogsService } from '../../../audit-logs/audit-logs.service';
import {
  AuditModule,
  AuditOperationType,
} from '../../../audit-logs/audit-logs.constants';

interface ProgressReportAuditParams {
  reportName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  caseId?: number;
  reason?: string;
}

@Injectable({ providedIn: 'root' })
export class ProgressReportAuditService {
  private readonly auditLogsService = inject(AuditLogsService);

  logPrinted(
    params: ProgressReportAuditParams
  ): Observable<ApiResponse<string> | null> {
    const reportName = this.toTitleCase(params.reportName) || 'Unknown';
    const studentName = this.buildStudentName(
      params.firstName,
      params.lastName
    );

    return this.auditLogsService.logAudit({
      auditModule: AuditModule.ProgressReport,
      auditOperationType: AuditOperationType.Printed,
      entityType: 'CaseProgressReport',
      summary: `${reportName} progress report is printed for ${studentName}`,
      caseId: params.caseId,
    });
  }

  logPrintFailed(
    params: ProgressReportAuditParams
  ): Observable<ApiResponse<string> | null> {
    const reportName = this.toTitleCase(params.reportName) || 'Unknown';
    const studentName = this.buildStudentName(
      params.firstName,
      params.lastName
    );

    return this.auditLogsService.logAudit({
      auditModule: AuditModule.ProgressReport,
      auditOperationType: AuditOperationType.Printed,
      entityType: 'CaseProgressReport',
      summary: `${reportName} progress report print failed for ${studentName}`,
      caseId: params.caseId,
    });
  }

  private buildStudentName(
    firstName?: string | null,
    lastName?: string | null
  ): string {
    const fullName = `${firstName || ''} ${lastName || ''}`.trim();
    return this.toTitleCase(fullName) || 'Unknown Student';
  }

  private toTitleCase(value?: string | null): string {
    if (!value) {
      return '';
    }

    return _.startCase(value.toLowerCase());
  }
}
